import script from "./ReportFormTwo.vue?vue&type=script&setup=true&lang=js"
export * from "./ReportFormTwo.vue?vue&type=script&setup=true&lang=js"

import "./ReportFormTwo.vue?vue&type=style&index=0&id=28bcd282&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-28bcd282"]])

export default __exports__